/**
 * The intro's own sequencing state and song cues.
 *
 * The pure "walk the ticks against elapsed time" state machine moved to
 * `shell/cutscene/cutscene-machine.ts` — it had nothing intro-specific in it
 * — and is re-exported here under its original names so nothing that already
 * imports `IntroState`/`createIntroState`/`advanceIntro`/`skipIntro` from
 * here has to change.
 *
 * `INTRO_SONG_CUES`/`songCueAt` stay: they are genuinely `TITLE.TTM`-specific
 * inferred timing (`intro.md`'s frame table, not derivable from the command
 * stream — see the cutscene player's own header for why every *other*
 * cutscene doesn't need a hand-measured table like this one).
 */

export type { CutsceneState as IntroState, CutsceneStep as IntroStep } from "../cutscene/cutscene-machine.ts";
export {
  advanceCutscene as advanceIntro,
  createCutsceneState as createIntroState,
  skipCutscene as skipIntro,
} from "../cutscene/cutscene-machine.ts";

/**
 * Which song slot should be sounding as of a given tick. `SELECT SONG` is a
 * silent state setter in the interpreter (it produces no command), so the
 * cue points come from `intro.md`'s frame table: `DYNAMIX.SNG` from the
 * vanity card at tick 1, `TITLE.SNG` cued with the fade-out at tick 20 and
 * carrying the title card through to the Main Menu.
 */
export const INTRO_SONG_CUES: readonly (readonly [number, string])[] = [
  [1, "DYNAMIX"],
  [20, "TITLE"],
];

export function songCueAt(tickIndex: number): string | undefined {
  return INTRO_SONG_CUES.find(([index]) => index === tickIndex)?.[1];
}
